import i18n from "@/locales/i18n";
import _ from "lodash";
import { enumI18nFormat } from "@/utils/lang";

const noContent = i18n.t("common.noContent");

export default function BuildPlanGroupInfo(plans) {
    if (_.isEmpty(plans)) {
        return {
            programName: noContent,
            planNames: noContent,
            classificationName: noContent,
            occupationName: noContent,
            occupationLevel: noContent,
            certificateType: noContent
        };
    }
    let registrationStudentCount = 0;
    let openedKlassStudentCount = 0;
    let unopenedKlassStudentCount = 0;
    const programNames = new Set();
    const planNames = new Set();
    const classificationNames = new Set();
    const occupationNames = new Set();
    const occupationLevels = new Set();
    const certificateTypes = new Set();
    _.each(plans, plan => {
        registrationStudentCount += _.get(plan, "planStudentStatistics.registrationStudentCount", 0);
        openedKlassStudentCount += _.get(plan, "planStudentStatistics.openedKlassStudentCount", 0);
        unopenedKlassStudentCount += _.get(plan, "planStudentStatistics.unopenedKlassStudentCount", 0);
        programNames.add(_.get(plan, "program.name"));
        planNames.add(plan.planName);
        classificationNames.add(_.get(plan, "program.occupationInfo.classificationName"));
        occupationNames.add(_.get(plan, "program.occupationInfo.occupationName"));
        const occupationLevel = _.get(plan, "program.occupationInfo.occupationLevel");
        occupationLevel && occupationLevels.add(enumI18nFormat("levelEnum", occupationLevel));
        const certificateType = _.get(plan, "setting.certificateType");
        certificateType && certificateTypes.add(enumI18nFormat("certificateTypeEnum", certificateType));
    });

    return {
        registrationStudentCount: registrationStudentCount,
        openedKlassStudentCount: openedKlassStudentCount,
        unopenedKlassStudentCount: unopenedKlassStudentCount,
        planName: _.defaultTo(_.join(_.toArray(planNames)), noContent),
        programName: _.defaultTo(_.join(_.toArray(programNames)), noContent),
        classificationName: _.defaultTo(_.join(_.toArray(classificationNames)), noContent),
        occupationName: _.defaultTo(_.join(_.toArray(occupationNames)), noContent),
        occupationLevel: _.defaultTo(_.join(_.toArray(occupationLevels)), noContent),
        certificateType: _.defaultTo(_.join(_.toArray(certificateTypes)), noContent)
    };
}
